export default "__VITE_ASSET__Cs4DKNu8__"